// source: pbtypes/gen/telit_lte_modem/modem_version_status.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_streaming_bitrate_controller_link_type_pb = require('../../../pbtypes/gen/streaming_bitrate_controller/link_type_pb.js');
goog.object.extend(proto, pbtypes_gen_streaming_bitrate_controller_link_type_pb);
var pbtypes_gen_telit_lte_modem_modem_type_pb = require('../../../pbtypes/gen/telit_lte_modem/modem_type_pb.js');
goog.object.extend(proto, pbtypes_gen_telit_lte_modem_modem_type_pb);
var pbtypes_gen_telit_lte_modem_modem_version_status_code_pb = require('../../../pbtypes/gen/telit_lte_modem/modem_version_status_code_pb.js');
goog.object.extend(proto, pbtypes_gen_telit_lte_modem_modem_version_status_code_pb);
goog.exportSymbol('proto.telit_lte_modem.ModemVersionStatus', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.telit_lte_modem.ModemVersionStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.telit_lte_modem.ModemVersionStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.telit_lte_modem.ModemVersionStatus.displayName = 'proto.telit_lte_modem.ModemVersionStatus';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.telit_lte_modem.ModemVersionStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.telit_lte_modem.ModemVersionStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telit_lte_modem.ModemVersionStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.telit_lte_modem.ModemVersionStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
modemType: jspb.Message.getFieldWithDefault(msg, 2, 0),
sourceLink: jspb.Message.getFieldWithDefault(msg, 3, 0),
statusCode: jspb.Message.getFieldWithDefault(msg, 4, 0),
flashProgress: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
expectedSwVersion: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telit_lte_modem.ModemVersionStatus}
 */
proto.telit_lte_modem.ModemVersionStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.telit_lte_modem.ModemVersionStatus;
  return proto.telit_lte_modem.ModemVersionStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telit_lte_modem.ModemVersionStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telit_lte_modem.ModemVersionStatus}
 */
proto.telit_lte_modem.ModemVersionStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setUtime(value);
      break;
    case 2:
      var value = /** @type {!proto.telit_lte_modem.ModemType.Enum} */ (reader.readEnum());
      msg.setModemType(value);
      break;
    case 3:
      var value = /** @type {!proto.streaming_bitrate_controller.LinkType.Enum} */ (reader.readEnum());
      msg.setSourceLink(value);
      break;
    case 4:
      var value = /** @type {!proto.telit_lte_modem.ModemVersionStatusCode.Enum} */ (reader.readEnum());
      msg.setStatusCode(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setFlashProgress(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setExpectedSwVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.telit_lte_modem.ModemVersionStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.telit_lte_modem.ModemVersionStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telit_lte_modem.ModemVersionStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.telit_lte_modem.ModemVersionStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeSint64(
      1,
      f
    );
  }
  f = message.getModemType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getSourceLink();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getStatusCode();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getFlashProgress();
  if (f !== 0.0) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = message.getExpectedSwVersion();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional sint64 utime = 1;
 * @return {number}
 */
proto.telit_lte_modem.ModemVersionStatus.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.telit_lte_modem.ModemVersionStatus} returns this
 */
proto.telit_lte_modem.ModemVersionStatus.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional ModemType.Enum modem_type = 2;
 * @return {!proto.telit_lte_modem.ModemType.Enum}
 */
proto.telit_lte_modem.ModemVersionStatus.prototype.getModemType = function() {
  return /** @type {!proto.telit_lte_modem.ModemType.Enum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.telit_lte_modem.ModemType.Enum} value
 * @return {!proto.telit_lte_modem.ModemVersionStatus} returns this
 */
proto.telit_lte_modem.ModemVersionStatus.prototype.setModemType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional streaming_bitrate_controller.LinkType.Enum source_link = 3;
 * @return {!proto.streaming_bitrate_controller.LinkType.Enum}
 */
proto.telit_lte_modem.ModemVersionStatus.prototype.getSourceLink = function() {
  return /** @type {!proto.streaming_bitrate_controller.LinkType.Enum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.streaming_bitrate_controller.LinkType.Enum} value
 * @return {!proto.telit_lte_modem.ModemVersionStatus} returns this
 */
proto.telit_lte_modem.ModemVersionStatus.prototype.setSourceLink = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional ModemVersionStatusCode.Enum status_code = 4;
 * @return {!proto.telit_lte_modem.ModemVersionStatusCode.Enum}
 */
proto.telit_lte_modem.ModemVersionStatus.prototype.getStatusCode = function() {
  return /** @type {!proto.telit_lte_modem.ModemVersionStatusCode.Enum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.telit_lte_modem.ModemVersionStatusCode.Enum} value
 * @return {!proto.telit_lte_modem.ModemVersionStatus} returns this
 */
proto.telit_lte_modem.ModemVersionStatus.prototype.setStatusCode = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional float flash_progress = 5;
 * @return {number}
 */
proto.telit_lte_modem.ModemVersionStatus.prototype.getFlashProgress = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.telit_lte_modem.ModemVersionStatus} returns this
 */
proto.telit_lte_modem.ModemVersionStatus.prototype.setFlashProgress = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional string expected_sw_version = 6;
 * @return {string}
 */
proto.telit_lte_modem.ModemVersionStatus.prototype.getExpectedSwVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.telit_lte_modem.ModemVersionStatus} returns this
 */
proto.telit_lte_modem.ModemVersionStatus.prototype.setExpectedSwVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


goog.object.extend(exports, proto.telit_lte_modem);
